import { useModalContext } from '@/hooks/useModalContext';
import { DownloadIcon } from '@/lib';
import { IconButton } from '@/lib/Buttons';
import { Audience } from '@/models/audiences';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDownloadModal } from './ConfirmDownloadModal';

type RequestAudienceDownloadButtonProps = {
  audience?: Audience;
};

export const RequestAudienceDownloadButton: FC<RequestAudienceDownloadButtonProps> = ({ audience }) => {
  const { t } = useTranslation('audience_details');
  const { openModal } = useModalContext();

  const handleClick = () => {
    if (audience) {
      openModal({
        renderContent: ConfirmDownloadModal,
        renderContentProps: {
          audience,
        },
        dismissable: false,
        fullWidth: false,
        fullHeight: false,
      });
    }
  };

  return <IconButton intent='secondary' onClick={handleClick} text={t('sources_and_rules.requestDownload')} leadingIcon={<DownloadIcon />} />;
};
